export const REDDIT_PRIMARY_COLOR = `#FF4500`
